import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TransferDetailsItem } from '@models/shopping-cart.model';
import { OrderTypeSettings } from '@models/shopping.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';

@Component({
  selector: 'ts-transfer-details-readonly',
  templateUrl: './transfer-details-readonly.component.html',
  imports: [CommonModule, TranslationPipe]
})
export class TransferDetailsReadonlyComponent {
  @Input() transfer_of_liability_attributes: TransferDetailsItem | undefined;
  @Input() order_type_settings: OrderTypeSettings;
}
